import { Link, useNavigate } from "react-router-dom";
import { LI, SVG, UL } from "../../../../AbstractElements";
import { userProfilesData } from "../../../../Data/Layout/HeaderData";
import axios from "axios";
import { toast } from "react-toastify";
import { URL_API } from "../../../../utils/helper/helpers";

const UserProfileIcons = () => {
  const navigate = useNavigate()
  const handleClick = async (name: string) => {
    if (name === "Log Out") {
      const Token = JSON.parse(localStorage.getItem("login")!);

      if (Token == null) {
        toast.info("Aucun token trouvé. Veuillez vous reconnecter.");
        return;
      }


      try {
        const response = await axios.post(`${URL_API}/logout`, {}, {
          headers: {
            Authorization: `Bearer ${Token}`
          }
        });
        if (response.status === 200) {
          localStorage.removeItem("login");
          localStorage.removeItem("user");
          localStorage.removeItem("permissions")

          navigate(`${process.env.PUBLIC_URL}/login`);
          toast.success("Déconnexion réussie");
        } else {
          toast.error(`Erreur lors de la déconnexion: ${response.statusText}`);
        }

      } catch (error: any) {
        const message = error.response?.data?.message || "Erreur de déconnexion";
        toast.info(message);
      }
    }
  };

  return (
    <UL>
      {userProfilesData.map((item, i) => (
        <LI className="d-flex" key={i}>
          <SVG className="svg-color" iconId={item.icon} />
          <Link className="ms-2" to={item.link} onClick={() => handleClick(item.title)} >
            {item.title}
          </Link>
        </LI>
      ))}
    </UL>
  );
};

export default UserProfileIcons;
